module.exports = __webpack_public_path__ + "static/media/VisiumGoLogo.818468f9.png";